import { ReactNode } from "react";
import { GAIAOBJECT_CATEGORY } from "utils/gaia-constants";

export interface IGenericDraftWizardProps {
  config: WizardConfig;
  visible?: boolean;
  onDismiss?: () => void;
  initialData?: any;
  isSubmitting?: boolean;
}

export interface WizardStepConfig {
  title: string;
  description?: string | ReactNode;
  content: ReactNode;
  isOptional?: boolean;
  validateWizardStep?: () => Promise<boolean>;
  onWizardStepValidationSuccess?: (data: any) => void;
  onWizardStepValidationError?: (errors: any) => void;
  triggerFormValidation?: () => void;
}

export interface WizardConfig {
  steps: WizardStepConfig[];
  category: GAIAOBJECT_CATEGORY;
  onComplete?: (data: any) => Promise<void>;
  onCancel?: () => void;
  submitButtonText?: string;
  cancelButtonText?: string;
  setStepAdvancementCallback?: (callback: (stepIndex: number) => void) => void;
  refetchDownloadUrl?: () => void;
  // Form persistence properties (used for wizard step advancement)
  formRef?: React.RefObject<any>;
  setStoredFormData?: (data: any) => void;
}

/**
 * Extended WizardConfig with form persistence helpers
 * Use this type when accessing formRef and setStoredFormData
 */
export interface WizardConfigWithFormPersistence extends WizardConfig {
  formRef: React.RefObject<any>;
  setStoredFormData: (data: any) => void;
}

/**
 * Type guard to check if config has form persistence capabilities
 */
export const hasFormPersistence = (
  config: WizardConfig,
): config is WizardConfigWithFormPersistence => {
  return !!(config.formRef && config.setStoredFormData);
};

export interface WizardStepData {
  [stepIndex: number]: any;
}

export interface WizardState {
  activeStepIndex: number;
  stepData: WizardStepData;
  isSubmitting: boolean;
}

export interface WizardActions {
  setActiveStepIndex: (index: number) => void;
  setStepData: (stepIndex: number, data: any) => void;
  setIsSubmitting: (submitting: boolean) => void;
  reset: () => void;
}
